import React, { useRef } from 'react';
import { FlexView } from '@cuemath/comps';
import { FilterDropdownMenu, FilterSearchInput, SA_COLORS } from '../../../styled-comps';
import {
  FilterItemWrap,
  FilterActions,
  FilterActionBtn,
  RenameInput,
  FilterErrorMsg,
} from '../styled';
import Icon from '../../icon';
import { Text } from '@cuemath/web-comps';

const FilterDropdown = ({
  filters,
  activeId,
  totalTickets,
  filterError,
  searchQuery,
  onSearchChange,
  renamingId,
  renameValue,
  onSelect,
  onStartRename,
  onConfirmRename,
  onCancelRename,
  onRenameChange,
  onDelete,
}) => {
  const renameErrorRef = useRef(null);

  return (
    <FilterDropdownMenu>
      <FilterSearchInput
        placeholder="Search filters..."
        value={searchQuery}
        onChange={onSearchChange}
        autoFocus
      />
      {filters.map(f => {
        const isActive = f.id === activeId;
        const isRenaming = renamingId === f.id;

        if (isRenaming) {
          return (
            <FlexView key={f.id} ref={renameErrorRef}>
              <FilterItemWrap $active={false} as="div">
                <RenameInput
                  autoFocus
                  value={renameValue}
                  onChange={e => onRenameChange(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') onConfirmRename();
                    if (e.key === 'Escape') onCancelRename();
                  }}
                  onClick={e => e.stopPropagation()}
                />
                <FilterActions style={{ opacity: 1 }}>
                  <FilterActionBtn onClick={onConfirmRename}>
                    <Icon name="check" size={14} />
                  </FilterActionBtn>
                  <FilterActionBtn onClick={onCancelRename}>
                    <Icon name="close" size={14} />
                  </FilterActionBtn>
                </FilterActions>
              </FilterItemWrap>
              {filterError && <FilterErrorMsg>{filterError}</FilterErrorMsg>}
            </FlexView>
          );
        }

        return (
          <FilterItemWrap key={f.id} $active={isActive} onClick={() => onSelect(f.id)}>
            <span>{f.label}</span>
            {f.isCustom ? (
              <FilterActions>
                <FilterActionBtn $active={isActive} onClick={e => onStartRename(e, f)}>
                  <Icon name="setting" size={12} />
                </FilterActionBtn>
                <FilterActionBtn $active={isActive} onClick={e => onDelete(e, f.id)}>
                  <Icon name="close" size={12} />
                </FilterActionBtn>
              </FilterActions>
            ) : (
              isActive && (
                <Text variant="body3" color={SA_COLORS.TEXT_TERTIARY}>
                  ({totalTickets})
                </Text>
              )
            )}
          </FilterItemWrap>
        );
      })}
    </FilterDropdownMenu>
  );
};

export default FilterDropdown;
